// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/OrderApprovals/Handlers/LoadOrderApprovals";

type HandlerType = Parameters<typeof RequestDataFromApi>[0];

// @override to delete the orderTotalOperator and orderTotal parameters when one of them empty
// to get the correct orders

export const RemoveInvaildParameters = (props: HandlerType) => {
    if (props.apiParameter?.orderTotalOperator && !props.apiParameter?.orderTotal) {
        delete props.apiParameter.orderTotalOperator;
    }

    if (props.apiParameter?.orderTotal && !props.apiParameter?.orderTotalOperator) {
        delete props.apiParameter.orderTotal;
    }
};

addToChainBefore(chain, RequestDataFromApi, RemoveInvaildParameters);
